/** @format */

export default [
    { scene: 'scene_82', id: 1, title: 'VR 라이브센터 입구'},
    { scene: 'scene_26', id: 2, title: '신제품 하이라이트 존'},
    { scene: 'scene_24', id: 3, title: '등록 데스크', lookat: '3.6815347212406166, 0'},
    { scene: 'scene_7', id: 4, title: '베스트 셀러 존', lookat: '-0.5161524968026939, 0'},
    { scene: 'scene_6', id: 5, title: '제품 디스플레이 존'},
    { scene: 'scene_3', id: 6, title: '스마트 뷰티 랩'},
    { scene: 'scene_8', id: 7, title: '제품 테스팅 존'},
    { scene: 'scene_1', id: 8, title: '피부 상담 존'},
    { scene: 'scene_30', id: 9, title: '체형 상담 존'},
    { scene: 'scene_11', id: 10, title: '뉴 비트(VR 바이크)'},
    { scene: 'scene_14', id: 11, title: '피트니스 라운지', lookat: '219.256784494982, 0'},
    { scene: 'scene_34', id: 12, title: '라이브 스튜디오'},
    { scene: 'scene_18', id: 13, title: '뉴 스퀘어', lookat: '98.43245639508142, 0'},
    { scene: 'scene_23', id: 14, title: '뉴 아뜰리에', lookat: '-78.03714180230386, 0'},
    { scene: 'scene_58', id: 15, title: '뉴스킨 쇼핑 라운지'},
    { scene: 'scene_83', id: 16, title: '반품실(A/S, 교환)', lookat: '8.311524580254359, 0'},
];
